"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const collageImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/geocosmos_ground_station_main.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/geocosmos_ground_station_main.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/geocosmos_ground_station_main.png-wvc-sizes",
  alt: "Advanced satellite ground station infrastructure",
  className: "w-full h-[400px] object-cover rounded-lg shadow-xl"
}, {
  src: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/82e68b59-b8e6-4cf6-bd71-1350435976d0-1.jpg?v=4e6g9zy1wop",
  srcset: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/82e68b59-b8e6-4cf6-bd71-1350435976d0-1.jpg?v=upabyzp75r-wvc-srcset",
  sizes: "https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/82e68b59-b8e6-4cf6-bd71-1350435976d0-1.jpg?v=yzuqtmbxerl-wvc-sizes",
  alt: "Orbital command control interface",
  className: "absolute -bottom-12 -left-8 w-48 h-48 object-cover rounded-lg shadow-2xl border-4 border-primary hidden md:block"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/fbcaf96d-aec4-4d83-bb94-fa22b4f7982c.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/fbcaf96d-aec4-4d83-bb94-fa22b4f7982c.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/fbcaf96d-aec4-4d83-bb94-fa22b4f7982c.png",
  alt: "High-gain satellite tracking antenna",
  className: "absolute -top-8 -right-8 w-40 h-40 object-cover rounded-lg shadow-lg border-4 border-primary hidden md:block"
}];
export default function ArtisanAlleySpotlight() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="257159" id="groundstationoverview" ref={sectionRef} className="relative w-full bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-primary/10 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className={`relative transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative max-w-md mx-auto lg:max-w-none">
              {collageImages.map((image, i) => <img key={i} data-index={i} src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} className={image.className} loading="lazy" />)}
              
              {}
              <div className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 z-20 w-32 h-32 md:w-40 md:h-40 drop-shadow-2xl animate-bounce" style={{
              animationDuration: '3s'
            }}>
                
              </div>
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="inline-flex items-center gap-2 border border-[#00d2ff] rounded-full px-4 py-1.5 text-white font-semibold text-xs tracking-widest uppercase mb-6 w-max bg-[#22c55e]/10">                       <Sparkles className="lucide lucide-sparkles w-4 h-4 !text-[rgba(0,210,255,1)]" />
              <span className="text-sm font-default tracking-widest uppercase !font-semibold">Տիեզերական ենթակառուցվածքներ
            </span>
            </div>
            
            <div className="space-y-6">
              <h2 className="text-4xl font-default font-bold leading-tight text-foreground !w-[650px] md:text-5xl lg:text-6xl">Վերգետնյա կայաններ</h2>
              
              <p className="text-lg md:text-xl text-foreground/80 font-default leading-relaxed max-w-xl">
                Վերգետնյա կայանները հանդիսանում են տիեզերական ենթակառուցվածքի կարևորագույն օղակը, ապահովելով անխափան կապ արբանյակների հետ:
              </p>
              
              <p className="text-foreground/70 font-default leading-relaxed max-w-xl !text-lg">
                Մեր բարձր տեխնոլոգիական կայանները հագեցած են ժամանակակից ընդունիչ և հաղորդիչ համակարգերով, որոնք թույլ են տալիս իրականացնել տվյալների արագ և անվտանգ փոխանակում տիեզերական սարքերի հետ ցանկացած պայմաններում:
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-default font-semibold rounded-md px-8 h-14 text-lg shadow-md transition-all hover:scale-105">
                
              </Button>
            </div>
            
            
          </div>

        </div>
      </div>
    </section>;
}